import { Draft, createSlice } from '@reduxjs/toolkit';
import { addAsyncCases } from 'shared/utils/redux';
import { User } from 'model/User';

import { fetchUser, getUserPermissions } from './asyncActions';
import { STORE_NAME, UserState } from './initialState';

export const userSlice = createSlice({
  name: STORE_NAME,
  initialState: UserState.INITIAL_DOMAIN,
  reducers: {
    clearUserPermissions: (state) => {
      if (state.data) {
        state.data.permissions = undefined;
      }
    },
  },
  extraReducers: (builder) => {
    addAsyncCases({
      builder,
      asyncActionCreator: fetchUser,
      reducer: (state, action) => {
        state.data = action.payload.data;
      },
    });

    builder.addCase(getUserPermissions.fulfilled, (state, action) => {
      state.data = action.payload as Draft<User>;
    });

    builder.addCase(getUserPermissions.rejected, (state) => {
      if (state.data) {
        state.data.permissions = [];
      }
    });
  },
});

export const { clearUserPermissions } = userSlice.actions;
